export default {
  params: ['target'],
  validate(value, { target }) {
    return value !== target
  }
}